import type { ValueOf } from 'type-fest';

export const taglineThemes = {
  Standard: 'standard',
  Campaign: 'campaign',
  Included: 'included',
} as const;

export type Tagline = {
  italic?: boolean;
  onDark?: boolean;
  theme?: ValueOf<typeof taglineThemes>;
  words: string[];
};
